import { PartialTranslation } from '../translations';

export const fi: PartialTranslation = {
  newChat: 'Uusi keskustelu',
  search: 'Haku',
  user: 'Käyttäjä',
  settings: 'Asetukset',
  language: 'Kieli',
  getHelp: 'Hae apua',
  viewAllPlans: 'Näytä kaikki suunnitelmat',
  learnMore: 'Lue lisää',
  logOut: 'Kirjaudu ulos',
  chooseLanguage: 'Valitse kieli',
  chooseYourPreferredLanguage: 'Valitse haluamasi kieli',
  searchLanguages: 'Hae kieliä...',
  autoDetect: 'Automaattinen tunnistus',
  noLanguagesFound: 'Kieliä ei löytynyt',
  askAnything: 'Kysy mitä tahansa',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Henkilökohtainen',
  freePlan: 'Ilmainen suunnitelma',
  current: 'Nykyinen',
  close: 'Sulje',
  archive: 'Arkistoi',
  delete: 'Poista',
  confirmDelete: 'Oletko varma, että haluat poistaa tämän keskustelun?',
  confirmArchive: 'Oletko varma, että haluat arkistoida tämän keskustelun?',
  deleteCannotUndo: 'Tätä toimintoa ei voi kumota.',
  archiveCanFind: 'Löydät sen arkistoluettelosta arkistoinnin jälkeen.',
  
  // 资源面板
  resources: 'Resurssit',
  addResource: 'Lisää resurssi',
  deleteResource: 'Poista resurssi',
  noMatchingResourcesFound: 'Vastaavia resursseja ei löytynyt',
  noResourcesAvailable: 'Resursseja ei ole saatavilla',
  hideResources: 'Piilota resurssit',
  showResources: 'Näytä resurssit',
  
  // 聊天输入框
  typeMessage: 'Kirjoita viesti...',
  thinkingOptions: 'Ajatteluvaihtoehdot',
  deleteFile: 'Poista tiedosto',
  clearSelection: 'Tyhjennä valinta',
  addAttachment: 'Lisää liite',
  sendMessage: 'Lähetä viesti',
  
  // 思考模式选项
  deepInsight: 'Syvä ymmärrys · Pintaanalyysi',
  deepInsightDesc: 'Nopea avainkohtien ymmärtäminen',
  deepExploration: 'Syvä tutkimus · Kattava analyysi',
  deepExplorationDesc: 'Moniulotteinen syvällinen tutkimus',
  deepDeconstruction: 'Syvä dekonstruktio · Järjestelmällinen argumentti',
  deepDeconstructionDesc: 'Kerros kerrokselta etenevä analyysi',
  
  // 写作模式选项
  contractReview: 'Sopimuksen tarkastelu · Riskien tunnistaminen',
  contractReviewDesc: 'Lausekkeiden analyysi ja vaatimustenmukaisuuden tarkistus',
  textPolish: 'Tekstin hiominen · Ammattimainen ilmaisu',
  textPolishDesc: 'Kielen optimointi ja rakenteellinen säätö',
  legalDocuments: 'Oikeudelliset asiakirjat · Vakioluonnos',
  legalDocumentsDesc: 'Ammattimainen oikeudellisten asiakirjojen kirjoittaminen',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Kirjaudu sisään',
  register: 'Rekisteröidy',
  welcomeBack: 'Tervetuloa LawHelperiin',
  loginSubtitle: 'AI Oikeudellinen Tutkimusassistenttisi',
  continueWithGoogle: 'Jatka Googlella',
  continueWithMicrosoft: 'Jatka Microsoftilla',
  continueWithWeChat: 'Jatka WeChatilla',
  orContinueWith: 'tai jatka',
  emailTab: 'Sähköposti',
  phoneTab: 'Puhelin',
  emailPlaceholder: 'Syötä sähköpostisi',
  phonePlaceholder: 'Syötä puhelinnumero',
  codePlaceholder: 'Syötä 6-numeroinen koodi',
  sending: 'Lähetetään...',
  verifying: 'Vahvistetaan...',
  verify: 'Vahvista',
  sendMagicLink: 'Lähetä taikainkki',
  getVerificationCode: 'Hanki koodi',
  resendCode: 'Lähetä koodi uudelleen',
  resendIn: 'Lähetä uudelleen',
  magicLinkSent: 'Taikalinkki lähetetty sähköpostiisi',
  magicLinkHint: 'Lähetämme suojatun linkin sähköpostiisi',
  otpSent: 'Vahvistuskoodi lähetetty',
  agreeToTerms: 'Jatkamalla hyväksyt meidän',
  privacyPolicy: 'Tietosuojakäytäntö',
  termsOfService: 'Käyttöehdot',
  and: 'ja',
  privacyTitle: 'Yksityisyytesi on tärkeä',
  privacyIntro: 'Käytämme evästeitä ja vastaavia teknologioita tarjotaksemme parhaan kokemuksen.',
  essentialCookies: 'Välttämättömät evästeet',
  essentialDesc: 'Vaaditaan sivuston toimintaan',
  analyticsCookies: 'Analytiikkaevästeet',
  analyticsDesc: 'Auttavat meitä parantamaan palvelua',
  marketingCookies: 'Markkinointievästeet',
  marketingDesc: 'Käytetään personoituun sisältöön',
  acceptAll: 'Hyväksy kaikki',
  essentialOnly: 'Vain välttämättömät',
  customize: 'Mukauta',
  savePreferences: 'Tallenna asetukset',
  back: 'Takaisin',
  readPrivacyPolicy: 'Lue tietosuojakäytäntömme',
  cookiePolicy: 'Evästekäytäntö',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI-tarkistus',
  aiDraft: 'AI-luonnos',
  smartAssistant: 'Malli',

  // 知识库搜索
  enableKnowledgeSearch: 'Ota haku käyttöön',
  knowledgeSearchDesc: 'AI hakee asiakirjoistasi',
  clickToDisable: 'Poista käytöstä',
  clickToEnable: 'Ota käyttöön',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Sulje resurssipaneeli',
  uploading: 'Ladataan %{fileName}...',
  processing: 'Käsitellään %{fileName}...',
  uploadSuccess: '✓ %{fileName} ladattu',
  uploadError: '✗ Lataus epäonnistui: %{error}',
  quickAnswer: 'Nopea vastaus',
  quickAnswerDesc: 'Nopea vastaus yksinkertaisiin kysymyksiin',
  cancelRequest: 'Peruuta',
  library: 'Kirjasto',
  filterAll: 'Kaikki',
  filterChat: 'Keskustelut',
  filterReview: 'Tarkistus',
  filterDraft: 'Luonnos',
  filterTemplate: 'Malli',
  filterForm: 'Lomake',
  thinking: 'Ajattelen...',
  thinkingProcess: 'Ajatteluprosessi',
  analyzingLegalLogic: 'Analysoidaan juridista logiikkaa...',
  lawhelperThinking: 'Lawhelper ajattelee...',
  serviceError: 'Palveluvirhe',
  uploaded: 'Ladattu',
  settingsGeneral: 'Yleiset',
  settingsNotifications: 'Ilmoitukset',
  settingsAppearance: 'Ulkoasu',
  settingsProfile: 'Profiili',
  settingsResponseNotifications: 'Vastausilmoitukset',
  settingsResponseNotificationsDesc: 'Ilmoitus kun AI on vastannut',
  settingsColorMode: 'Väritila',
  settingsLight: 'Vaalea',
  settingsDark: 'Tumma',
  settingsSystem: 'Järjestelmä',
  about: 'Tietoja',
  reviewTitle: 'Asiakirjan tarkistus',
  exitReview: 'Poistu tarkistuksesta',
  uploadPrompt: 'Lataa PDF tarkistettavaksi',
  uploadButton: 'Valitse tiedosto',
  startChatConfig: 'Kirjoita "Tarkista tämä asiakirja" aloittaaksesi',
  reviewPlaceholder: 'Kirjoita viesti tai "Tarkista tämä asiakirja"...',
  analyzing: 'Tarkistetaan...',
  reviewComplete: 'Tarkistus valmis',
  issuesFound: '%{count} ongelmaa löydetty',
  draftTitle: 'Oikeudellinen asiakirjan laadinta',
  draftPlaceholder: 'Muokkaa tai pyydä AI:ta luomaan...',
  analyzingTemplate: 'Analysoidaan mallia %{name}...',
  templateAnalyzed: '✅ Malli %{name} analysoitu!',
  templateAnalysisPrompt: 'Analysoi mallin keskeiset lausekkeet',
  parsingFailed: '⚠️ Tiedoston jäsennys epäonnistui, mutta voit kuvata tarpeesi.',
  generating: 'Luodaan...',
  generatedSuccess: '✅ Asiakirja luotu!',
  drafterWelcome: 'Tervetuloa AI-asiakirja-avustajaan',
  drafterYouCan: 'Voit:',
  drafterUploadTemplate: 'Ladata mallin AI-analyysia varten',
  drafterDescribeNeeds: 'Kuvata asiakirjavaatimuksesi',
  drafterLetAiHelp: 'AI auttaa sopimusten laadinnassa',
  drafterExamples: 'Esimerkkejä:',
  drafterExampleRental: '"Laadi vuokrasopimus"',
  drafterExampleLabor: '"Täytä työsopimus mallin mukaan"',
  drafterInputPlaceholder: 'Kuvaa asiakirjatarpeesi...',
  drafterThinking: 'Ajattelen...',
  drafterHistoryTitle: 'Historia',
  drafterNoHistory: 'Ei historiaa',
  drafterNewChat: 'Uusi keskustelu',
  drafterHistory: 'Historia',
  drafterRemoveAttachment: 'Poista liite',
  drafterLineHeight: 'Riviväli',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Vie Word-muotoon (.docx)',
  drafterExportPdf: 'Vie PDF-muotoon',
  drafterSave: 'Tallenna asiakirja',
  drafterDownload: 'Lataa asiakirja',
  drafterUndo: 'Kumoa',
  drafterRedo: 'Tee uudelleen',
  drafterBold: 'Lihavoitu',
  drafterItalic: 'Kursiivi',
  drafterStrike: 'Yliviivaus',
  drafterUnderline: 'Alleviivaus',
  drafterHighlight: 'Korostus',
  drafterLink: 'Lisää linkki',
  drafterAlignLeft: 'Vasen tasaus',
  drafterAlignCenter: 'Keskitys',
  drafterAlignRight: 'Oikea tasaus',
  drafterAlignJustify: 'Tasaus',
  drafterList: 'Lista',
  drafterBulletList: 'Luettelomerkit',
  drafterOrderedList: 'Numeroitu lista',
  drafterTaskList: 'Tehtävälista',
  drafterOpenResource: 'Avaa resurssipaneeli',
  drafterStopGeneration: 'Lopeta luonti',
  drafterAgentMode: 'Agenttitila aktiivinen | Napsauta vaihtaaksesi',
  drafterAgentModeOn: 'Agenttitila aktiivinen',
  drafterAgentModeOff: 'Normaali tila',
  drafterUploadAttachment: 'Lataa liite',
  drafterExit: 'Poistu',
  drafterConfirm: 'Vahvista',
  drafterOpenLink: 'Avaa linkki',
  drafterDeleteLink: 'Poista linkki',
  drafterQuote: 'Lainaus',
  workflowTitle: 'AI-työnkulku',
  workflowRunning: 'Käynnissä...',
  workflowReady: 'Valmis',
  workflowCompleted: 'Valmis',
  workflowStartFailed: 'Työnkulun käynnistys epäonnistui',
  workflowExecutionFailed: 'Työnkulun suoritus epäonnistui',
  workflowInterrupted: 'Työnkulku keskeytetty',
  workflowProcessing: 'Käsitellään...',
  workflowStepsCompleted: 'vaihetta suoritettu',
  workflowStepsTotal: 'Työnkulku valmis (%{count} vaihetta)',
  acceptChanges: 'Hyväksy muutokset',
  rejectChanges: 'Hylkää muutokset',
  changesAccepted: 'Muutokset hyväksytty',
  changesRejected: 'Muutokset hylätty',
  stopWorkflow: 'Pysäytä',
  restartWorkflow: 'Käynnistä uudelleen',
  startDrafting: 'Aloita laadinta',
  interrupt: 'Pysäytä',
  documentSubject: 'Asiakirjan aihe *',
  documentType: 'Asiakirjatyyppi',
  jurisdiction: 'Lainkäyttöalue',
  specialRequirements: 'Erityisvaatimukset (valinnainen)',
  clickStartDrafting: 'Napsauta "Aloita laadinta" aloittaaksesi',
  docTypeContract: 'Sopimus',
  docTypeAgreement: 'Sopimus',
  docTypeNotice: 'Ilmoitus',
  docTypeLetter: 'Kirje',
  docTypePetition: 'Vetoomus',
  docTypeWill: 'Testamentti',
  docTypePowerOfAttorney: 'Valtakirja',
  countryChina: 'Kiina',
  countryUSA: 'Yhdysvallat',
  countryGermany: 'Saksa',
  countryJapan: 'Japani',
  countryFrance: 'Ranska',
  countryUK: 'Iso-Britannia',
  citationVerified: 'Vahvistettu',
  citationUnverified: 'Vahvistamaton',
  imageLoadFailed: 'Kuvan lataus epäonnistui',
  smartDocTitle: 'Älykäs asiakirja-avustaja',
  smartDocChatTitle: 'AI-asiakirja-avustaja',
  smartDocDropPrompt: 'Pudota PDF-tiedosto tähän',
  smartDocSelectFile: 'Valitse tiedosto',
  smartDocOr: 'tai',
  smartDocWelcomeTitle: 'Tervetuloa AI-asiakirja-avustajaan',
  smartDocWelcomeYouCan: 'Voit:',
  smartDocUploadForAI: 'Ladata mallin AI-analyysiin',
  smartDocDescribeDoc: 'Kuvata vaatimukset',
  smartDocLetAIDraft: 'AI auttaa sopimuksissa',
  smartDocExamples: 'Esimerkkejä:',
  smartDocExampleRental: '"Laadi vuokrasopimus"',
  smartDocExampleLabor: '"Täytä työsopimus"',
  smartDocInputPlaceholder: 'Kuvaa tarpeesi...',
  smartDocRemoveAttachment: 'Poista liite',
  smartDocOpenResources: 'Avaa resurssipaneeli',
  smartDocExit: 'Poistu',
  reviewStartFailed: 'Tarkistuksen käynnistys epäonnistui',
  reviewFailed: 'Tarkistus epäonnistui',
  reviewFoundIssues: 'Tarkistus valmis, %{count} ongelmaa.',
  cannotReadStream: 'Vastausvirran lukeminen epäonnistui',
  parseEventFailed: 'Tapahtuman jäsennys epäonnistui',
  errorPrefix: 'Virhe',
  unknownError: 'Tuntematon virhe',
  file: 'Tiedosto',
  loading: 'Ladataan...',
  localFolders: 'Paikalliset kansiot',
  selectLocalFolder: 'Valitse paikallinen kansio',
  reselectFolder: 'Vaihda kansiota',
  addToContext: 'Lisää keskusteluun',
  saveFile: 'Tallenna',
  renameFile: 'Nimeä uudelleen',
  fileSaved: 'Tiedosto tallennettu',
  fileRenamed: 'Tiedosto nimetty uudelleen: %{name}',
  browserNotSupported: 'Selaimesi ei tue paikallista kansiohakua',
  noFolderSelected: 'Valitse paikallinen kansio tiedostojen selaamiseen',
  scanningFolder: 'Skannataan kansiota...',
  selectFileToPreview: 'Valitse tiedosto esikatselua varten',
  aiAnalyze: 'AI-analyysi',
};
